// extracted by mini-css-extract-plugin
export default {"app":"handoff_app__tlC5z","appIcon":"handoff_appIcon__mEaMM","page":"handoff_page__XpOZO"};